
  export default {
    name: 'DefaultDrawerRight',
    data() {
      return {
        switchToTitle: 'Zu Jobanbieter wechseln',
        colors: [this.$vuetify.theme.themes.light.primary],
        menu: false,
      };
    },
  };
